module.exports = __webpack_public_path__ + "img/zy.43822044.png";